import * as NameSpace from 'src/store/NameSpace'
import { ParseService } from '../../Services/parse'
import { FlexTable } from 'src/components/shared/flexTables'
import { cloneDeep } from 'lodash'
// import { approveWithChangesMock } from 'src/components/pop-up/approveWithChangesMock'
// import { approveWithChangesSchema } from 'src/components/pop-up/approveWithChangesSchema'

const state = {
  [NameSpace.APPROVE_WITH_CHANGES_OLD]: {
    data: []
  },
  [NameSpace.APPROVE_WITH_CHANGES]: {
    headers: [],
    data: [],
    success: false,
    error: null,
    showAgain: null,
    itemRemoved: false
  },
  [NameSpace.APPROVE_WITH_CHANGES_RESULT]: {
    result: null,
    success: false
  }
}

const getters = {
  [NameSpace.GET_APPROVE_WITH_CHANGES_OLD]: state => {
    return state[NameSpace.APPROVE_WITH_CHANGES_OLD]
  },
  [NameSpace.GET_APPROVE_WITH_CHANGES]: state => {
    return state[NameSpace.APPROVE_WITH_CHANGES]
  },
  [NameSpace.GET_APPROVE_WITH_CHANGES_RESULT]: state => {
    return state[NameSpace.APPROVE_WITH_CHANGES_RESULT]
  }
}

const mutations = {
  [NameSpace.MUTATE_APPROVE_WITH_CHANGES_OLD]: (state, payload) => {
    state[NameSpace.APPROVE_WITH_CHANGES_OLD] = payload
  },
  [NameSpace.MUTATE_APPROVE_WITH_CHANGES]: (state, payload) => {
    state[NameSpace.APPROVE_WITH_CHANGES] = payload
  },
  [NameSpace.MUTATE_APPROVE_WITH_CHANGES_RESULT]: (state, payload) => {
    state[NameSpace.APPROVE_WITH_CHANGES_RESULT] = payload
  }
}

const actions = {
  [NameSpace.FETCH_APPROVE_WITH_CHANGES]: ({ commit }, payload) => {
    ParseService.getEditOfferItems(payload)
    .then(offers => {
      let result = getUpApproveWithChanges(offers)
      commit(NameSpace.MUTATE_APPROVE_WITH_CHANGES, result)
      commit(NameSpace.MUTATE_APPROVE_WITH_CHANGES_OLD, cloneDeep(result.data))
    })
    .catch(error => {
      commit(NameSpace.MUTATE_APPROVE_WITH_CHANGES, {
        headers: [],
        data: [],
        success: false,
        error: error,
        showAgain: true,
        itemRemoved: false
      })
    })
  },
  [NameSpace.SUBMIT_OFFER_LOCK]: ({ commit }, payload) => {
    ParseService.approveWithChanges(payload)
    .then(result => {
      let hasWarning = false
      if (result && result.warnings && result.warnings.length) {
        hasWarning = true
      }
      if (hasWarning) {
        commit(NameSpace.MUTATE_APPROVE_WITH_CHANGES_RESULT, { result: setUpZonePriceData(result), success: true, error: result.warnings })
      } else {
        commit(NameSpace.MUTATE_APPROVE_WITH_CHANGES_RESULT, { result: setUpZonePriceData(result), success: true })
      }
    })
    .catch(error => {
      commit(NameSpace.MUTATE_APPROVE_WITH_CHANGES_RESULT, {
        result: {
          headers: [],
          data: [],
          success: false,
          error: error,
          showAgain: true
        },
        success: false
      })
    })
  },
  [NameSpace.ACTION_REMOVE_ITEM_BY_ID]: ({ commit }, payload) => {
    ParseService.removeItemById(payload)
    .then(offers => {
      let result = getUpApproveWithChanges(offers)
      commit(NameSpace.MUTATE_APPROVE_WITH_CHANGES, result)
      commit(NameSpace.MUTATE_APPROVE_WITH_CHANGES_OLD, cloneDeep(result.data))
    })
    .catch(error => {
      console.log('ERROR:::', error)
      commit(NameSpace.MUTATE_APPROVE_WITH_CHANGES, {
        headers: [],
        data: [],
        success: false,
        error: error,
        showAgain: true,
        itemRemoved: false
      })
    })
  },
  [NameSpace.HARD_RESET_APPROVE_WITH_CHANGES]: ({ commit }, payload) => {
    if (payload) {
      let stateObject = state[NameSpace.APPROVE_WITH_CHANGES]
      stateObject.data = payload
      commit(NameSpace.MUTATE_APPROVE_WITH_CHANGES, stateObject)
    } else {
      commit(NameSpace.MUTATE_APPROVE_WITH_CHANGES, {
        headers: [],
        data: [],
        success: false,
        error: null,
        showAgain: null,
        itemRemoved: false
      })
    }
  }
}

function getUpApproveWithChanges (offers) {
  let copyData = cloneDeep(offers)
  const { header, data } = copyData
  let items = data.items
  if (items.length === 0) {
    let result = {
      headers: [],
      data: null,
      success: false,
      error: null,
      showAgain: null,
      itemRemoved: false
    }
    return result
  } else {
    let tableInstance = new FlexTable(header, items, 1)
    let toDeleteHeaders = tableInstance.getLinkableHeaders(header, 'delete')
    toDeleteHeaders.forEach(field => {
      delete header[field]
    })
    let tableHeaders = tableInstance.getObjectTableHeaders(header)
    let tableHeaderString = tableInstance.getStringTableHeaders(header)
    let editableHeaders = tableInstance.getIndexforFillteredTableHeaders(header, 'makeEditable')
    let tableData = tableInstance.getCellDataAsObject(tableHeaderString, items, 'makeEditable', 'approve_with_changes', 100, editableHeaders)
    for (let i = 0; i < items.length; i++) {
      tableData[i]['itemId'] = items[i].itemId
      let itemObject = tableData[i][0]
      for (let c = 0; c < tableData[i].length; c++) {
        let record = tableData[i][c]
        if (record.editable) {
          record.clickAway = true
        }
      }
      itemObject.arrow_for_close = true
      itemObject.itemIndex = i
    }
    tableData[tableData.length - 1].forEach(record => {
      if (record.editable) {
        record.clickAway = true
      }
    })
    let result = {
      headers: tableHeaders,
      data: tableData,
      success: true,
      error: null,
      itemRemoved: data.itemRemoved
    }
    return result
  }
}

function setUpZonePriceData (approveResult) {
  let tableInstance = new FlexTable(approveResult.header, approveResult.data, 0)
  const resultHeader = tableInstance.getObjectTableHeaders(approveResult.header, 'Zone Id')
  let tableHeadersString = tableInstance.getStringTableHeaders(approveResult.header)
  const editableHeader = tableInstance.getIndexforFillteredTableHeaders(approveResult.header, 'makeEditable')
  const tableData = tableInstance.getCellDataAsObject(tableHeadersString, approveResult.data, 'makeEditable', 'set_zone', 100, editableHeader)
  for (let array of tableData) {
    array.splice(0, 1)
  }
  let result = {
    headers: resultHeader,
    data: tableData,
    success: true,
    error: null,
    showAgain: true,
    itemRemoved: false
  }
  return result
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/approveWithChanges.js